import { fromUnixTime, format } from 'date-fns';

import { STEP_TYPES } from './constants';
import { TIME_UNITS } from '../_global/constants';

const singleDay = 60 * 60 * 24;
export function getTimeUnit(dateRange) {
  if (dateRange.endDate - dateRange.startDate < 30 * singleDay) return 1;
  if (dateRange.endDate - dateRange.startDate < 180 * singleDay) return 7;
  return 28;
}

export function getEnumTimeUnit(dateRange) {
  if (dateRange.endDate - dateRange.startDate < 30 * singleDay) return TIME_UNITS.DAY;
  if (dateRange.endDate - dateRange.startDate < 180 * singleDay) return TIME_UNITS.WEEK;
  return TIME_UNITS.MONTH;
}

export function charDateLabel(date) {
  return format(fromUnixTime(date), 'MMM d');
}

export function convertStepsToEditorFormat(visitStep, goalSteps) {
  const result = [];
  if (visitStep) {
    result.push({ type: STEP_TYPES.VISIT });
  }
  goalSteps.forEach((g) => result.push({ type: STEP_TYPES.GOAL, id: g.id }));

  return result;
}

export function convertGoalStepsToDBFormat(steps) {
  return steps.filter((s) => s.type === STEP_TYPES.GOAL).map((s) => s.id);
}
